export type UseFormFieldsValidation = {
  validated: Ref<boolean>;
  releaseFieldInvalidate: (name) => void;
  forceFieldInvalidate: (name) => void;
  forcedInvalalidatedFields: Ref<string[]>;
};

export const useFormFieldsValidation = (
  fields: Ref<FormField[]>,
  model: Ref<any>
): UseFormFieldsValidation => {
  const validated = ref<boolean>(false);

  const forcedInvalalidatedFields = ref<string[]>([]);

  // use to force invalidation example phone numbre
  const forceFieldInvalidate = (fieldName: string) => {
    // already invalidated
    if (forcedInvalalidatedFields.value.find((n) => n === fieldName)) return;

    forcedInvalalidatedFields.value.push(fieldName);
  };
  const releaseFieldInvalidate = (fieldName: string) => {
    forcedInvalalidatedFields.value = forcedInvalalidatedFields.value.reduce(
      (acc, name) => {
        if (name !== fieldName) {
          acc.push(name);
        }
        return acc;
      },
      []
    );
  };

  const isInvalidationForced = computed(() => {
    return forcedInvalalidatedFields.value.length > 0;
  });

  const currentFieldNames = computed(() =>
    fields.value.map((field) => field.name)
  );

  const cleanForcedInvalalidatedFields = () => {
    forcedInvalalidatedFields.value = forcedInvalalidatedFields.value.reduce(
      (acc, name) => {
        if (currentFieldNames.value.includes(name)) {
          acc.push(name);
        }
        return acc;
      },
      []
    );
  };

  watch(
    () => forcedInvalalidatedFields.value,
    () => {}
  );

  watchEffect(() => {
    cleanForcedInvalalidatedFields();

    if (isInvalidationForced.value) {
      validated.value = false;
    } else {
      const notValidated = fields.value.some((field) => {
        if (model.value[field.name]) {
          const validate = isFormFieldValidate(field, model);
          return !validate;
        } else {
          return false;
        }
      });
      validated.value = !notValidated;
    }
  });

  return {
    forceFieldInvalidate,
    releaseFieldInvalidate,
    validated,
    forcedInvalalidatedFields,
  };
};
